(ns ui.view.card.shared-components.card-container
  (:require [ui.util :as uu]))

(defn view
  [props-candidate & children]
  (let [props (if (map? props-candidate)
                props-candidate
                {})
        children (if (map? props-candidate)
                   children
                   (cons props-candidate children))
        classname (:class props)
        props (dissoc props :class)]
    (into
     [:div
      (merge
       {:class (uu/cm "group/card px-3 py-2 rounded-md border border-solid border-base-light-border-paler bg-base-light"
                      classname)}
       props)]
     children)))

